module.exports = __webpack_public_path__ + "img/5.a2088f44.jpg";